
  interface Array<T> {
    isEmpty(): boolean;
    isNotEmpty(): boolean;
    
    isNuDe(): boolean;
    isNotNuDe(): boolean;
  }

  Array.prototype.isEmpty = function () {
    if(this.length == 0) return true
    return false;
  }
  
  Array.prototype.isNotEmpty = function () {
    if(this.length != 0) return true
    return false;
  }
  
  Array.prototype.isNuDe = function () {
    if(this == null && this == undefined) return true
    return false;
  }
  
  Array.prototype.isNotNuDe = function () {
    if(this == null && this == undefined) return false
    return true;
  }
